<template>
  <div>
    Ime: {{report.ime}}
    <br>
    Priimek: {{report.pri}}
    <br>
    ID Namestitvenega Obrata: {{report.idNO}}
    <br>
    Datum Rojstva: {{report.dtRoj | date}}
    <br>
    Država: {{report.drzava | country}}
    <br>
    Čas Prihoda: {{report.casPrihoda | date}} {{report.casPrihoda | time}}
    <br>
    Čas Odhoda: {{report.casOdhoda | date}} {{report.casOdhoda | time}}
    <br>
    Številka Dokumenta: {{report.idStDok}}
    <br>
    Vrsta dokumenta: {{report.vrstaDok | document(documents)}}
    <br>
    Status:
    <span v-bind:class="report.status == 1 ? 'text-success' : 'text-danger'">
      {{report.status | status}}
    </span>
    <br>
    Obračun turistične takse: {{report.ttObracun | touristTax(touristTaxes)}}
    <br>
    Višina turistične takse: {{report.ttVisina | currency}}&euro;
    <br>
    Updated: {{report.updated | date}} {{report.updated | time}}
    <br>
    <button class="btn btn-primary mt-5" @click="reportGuest(1)" :disabled="!$route.params.guestId">Report</button>
    <button type="button" class="btn btn-danger mt-5" @click="reportGuest(2)"  :disabled="!(report && report.status == 1)">Storno</button>
  </div>
</template>

<script>
  import moment from 'moment';
  const countryList = require('country-list');

  export default {
    name: 'Report',
    props: ['socket', 'documents', 'touristTaxes', 'property', 'report', 'checkIn', 'checkOutDate'],
    filters: {
      date: function(date){
        if(!date) return '';
        return moment(date).format('DD/MM/YYYY');
      },
      time: function(date){
        if(!date) return '';
        return moment(date).format('HH:mm:ss');
      },
      currency: function(value){
        return parseFloat(value).toFixed(2);
      },
      document: function(value, documents = []){
        let document = documents.find(d => d.value == value);
        return document ? document.text : ""
      },
      touristTax: function(value, touristTaxes = []){
        console.log(value);
        console.log(touristTaxes)
        let touristTax = touristTaxes.find(t => t.value == value);
        return touristTax ? touristTax.text : ""
      },
      country: function(value){
        let country = countryList.getData().find(c => c.code == value);
        return country ? country.name : ""
      },
      status: function(value){
        if(!value) return "";
        return value == 1 ? "Valid" : "Canceled"
      }
    },
    created(){
      if(this.$route.params.guestId){

        fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId + '/eTurizem', {
          method: 'get',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          },
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          console.log("response report")
          console.log(response);
          if(response.length){
            this.$emit('update:report', response[0])
          }
        })
      }
    },
    methods: {
      reportGuest: function(status){
        fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId + '/eTurizem', {
          method: 'post',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          },
          body: JSON.stringify({
            report: {
              status: status
            },
            socket: {
              id: this.socket.id
            }
          })
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          if(response.knjigaGostov){
            console.log("knjigaGostov")
            console.log(response.knjigaGostov);

            if(this.checkIn.date + 'T' + this.checkIn.time <= moment().format('YYYY-MM-DD[T]HH:mm:ss') && this.$store.state.newGuests.find(g => g._id == this.property._id)){
              if(response.knjigaGostov.status == 1){
                if((this.report.status != 1 && this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests > 0)
                || this.report.casOdhoda != this.checkOutDate)
                {
                  this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests -= 1;
                }
              }else{
                this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests += 1;
              }
              this.$store.commit('changeGuests', this.$store.state.newGuests.find(g => g._id == this.property._id))
            }

            this.$emit('update:report', response.knjigaGostov);

          }else if(response.error){
            console.log(response.error)
          }
        })
      }
    }
  }
</script>
